// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"Iw6uNyDs","main":"fkY9r4H_","content":"_1TdJ1_nS","active":"_36iT37aw","buttons":"_1Sdlvd1m","stravaButton":"_2qMopd5y","registoButton":"_1FPfJZ8c","plan-waring":"_2EhkpEMV","bar":"_1POBL3kg","insideDiv":"_3469I0gP","workoutContent":"_2C0JirP3"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/pages/WorkoutPage/WorkoutPage.styl
// module id = 525
// module chunks = 0